angular.module('leanlaw').controller('PaymentSummaryCtrl', ['$q', '$scope', '$window', '$state', '$stateParams', '$filter', 'userService', 'singleRequest', 'clientManager', 'alerts', 'invoiceFilterService', 'exportJson', function ($q, $scope, $window, $state, $stateParams, $filter, userService, singleRequest, clientManager, alerts, invoiceFilterService, exportJson) {
  let loadedFilter;
  $scope.vm = {
    query: '',
    sort: ['client.label', 'matter.label'],
    reverse: false,
    filteredClients: {},
    currPage: 1,
    pageSize: 30,
    pageSizePrev: 30,
    state: invoiceFilterService.state,
    client: {},
    me: {},
    loading: false,
    total: 0,
    numClients: 0,
    lastPage: 1
  };
  $scope.calcLastPage = calcLastPage;
  $scope.exportExcel = exportExcel;
  $scope.print = () => {
    $window.print();
  };
  $scope.selectClient = function (client) {
    if (client.billing.billClient) {
      $state.go("^.matter", {
        clientId: client.id
      });
    }
  };
  activate();

  ////////////////////////

  var _clients = null;
  function activate() {
    if ($stateParams.clientId) {
      $scope.vm.client = {
        id: $stateParams.clientId
      };
    }
    clientManager.list({
      scope: 'all',
      matters: 'include'
    }).then(clients => {
      _clients = clients;
      $scope.$watch('state.filter', () => {
        reload();
      }, true);
      $scope.$watch('state.cm', () => {
        reload();
      }, true);
    });
    userService.me().then(me => {
      $scope.vm.me = me;
    });
  }
  function reload() {
    const query = {
      primary: 'clients',
      data: 'receivables,aging',
      zeros: false,
      matters: 'include',
      source: 'reports',
      billed: 'all',
      billedState: 'all'
    };
    if ($scope.vm.state.filter.scope) {
      query.scope = $scope.vm.state.filter.scope;
    }
    if ($scope.vm.state.filter.scopeAccount) {
      query.scopeAccount = $scope.vm.state.filter.scopeAccount.id;
    }
    if ($scope.vm.state.filter.matterTag) {
      query.matterTag = $scope.vm.state.filter.matterTag;
    }
    if ($scope.vm.state?.cm?.matter) {
      query.matterId = $scope.vm.state.cm.matter.id;
    }
    if ($scope.vm.state?.cm?.client) {
      query.clientId = $scope.vm.state.cm.client.id;
    }
    if (loadedFilter && loadedFilter.scope === query.scope && loadedFilter.scopeAccount === query.scopeAccount && loadedFilter.matterTag === query.matterTag && loadedFilter.matterId === query.matterId && loadedFilter.clientId === query.clientId) {
      return;
    }
    loadedFilter = query;
    $scope.vm.loading = true;
    singleRequest.apiCall("receivables", true).getReport(query).then(report => {
      if (!report) return;
      $scope.vm.clients = report.clients;
      $scope.vm.clients.forEach(client => {
        if (!client.matters || client.matters.length === 0) {
          const clientWithMatters = _clients.find(c => c.id === client.client.id);
          if (clientWithMatters) {
            // eslint-disable-next-line no-param-reassign
            client.responsibles = _.uniq(clientWithMatters.matters.map(m => m.primary.name)).join("</br>");
          }
        }
      });
      $scope.vm.total = _.reduce($scope.vm.clients, (sum, c) => {
        const {
          aging,
          balance
        } = c.data.accounting;
        const safeBal = balance || 0.0;
        return {
          balance: sum.balance + safeBal,
          current: sum.current + aging.current,
          under30: sum.under30 + aging.under30,
          over30: sum.over30 + aging.over30,
          over60: sum.over60 + aging.over60,
          over90: sum.over90 + aging.over90
        };
      }, {
        balance: 0,
        current: 0,
        under30: 0,
        over30: 0,
        over60: 0,
        over90: 0
      });
      // $scope.total = _.reduce($scope.clients, (sum, c) => sum + c.data.accounting.balance, 0);
      $scope.vm.numClients = $scope.vm.clients.length;
      $scope.vm.loading = false;
    }).catch(err => {
      alerts.error(err);
      $scope.vm.loading = false;
    });
  }
  function calcLastPage() {
    $scope.vm.lastPage = Math.ceil($scope.vm.numClients / $scope.pageSize);
  }
  function exportExcel() {
    const currencyFilter = $filter('currency');
    function makeRow(item, label, responsible) {
      return {
        "Client and Matter": label,
        Responsible: responsible,
        "Account Balance": currencyFilter(item.data.accounting.balance, '$', 2),
        "Current": currencyFilter(item.data.accounting.aging.current, '$', 2),
        "1-30 Days": currencyFilter(item.data.accounting.aging.under30, '$', 2),
        "31-60 Days": currencyFilter(item.data.accounting.aging.over30, '$', 2),
        "61-90 Days": currencyFilter(item.data.accounting.aging.over60, '$', 2),
        "> 90 Days": currencyFilter(item.data.accounting.aging.over90, '$', 2)
      };
    }
    const items = [];
    $scope.vm.filteredClients.forEach(c => {
      items.push(makeRow(c, c.client.label, c.responsibles, false));
      c.matters.forEach(m => {
        items.push(makeRow(m, ` - ${m.matter.label}`, m.matter.primary.name));
      });
    });
    exportJson.downloadCsv(items, 'Receivables');
  }
}]);